import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/internal/operators/map";
import { AutomapperService } from "../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../core/environment.tokens";
import { MemberChartM360Response } from "./member-chart-response.model";
import { MemberItem } from "./member-item.model";
import { MemberM360Response } from "./member-response.model";

@Injectable({
  providedIn: "root",
})
export class MemberV2Service {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService
  ) { }

  searchMembers(searchRequest: any, isSearch: boolean = false): Observable<MemberM360Response> {
    const endpoint = isSearch ? "search" : "query";
    const url = `${this.baseApiUrl}m360/members/${endpoint}`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post(url, searchRequest, { headers }).pipe(
      map(this.automapper.curry("default", "MemberM360Response"))
    );
  }

  listPotentialDuplicates(searchRequest: any): Observable<MemberM360Response> {
    const url = `${this.baseApiUrl}m360/members/potentialduplicates`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post(url, searchRequest, { headers }).pipe(
      map(this.automapper.curry("default", "MemberM360Response"))
    );
  }

  resolveDuplicateMembers(request: any): Observable<any> {
    const url = `${this.baseApiUrl}m360/members/resolve-duplicates`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post(url, request, { headers });
  }

  mergeDuplicateMembers(request: any): Observable<any> {
    const url = `${this.baseApiUrl}m360/members/merge-duplicates`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post(url, request, { headers });
  }

  getManyMembers(request: any): Observable<MemberItem[]> {
    const url = `${this.baseApiUrl}m360/members/get-many`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post(url, request, { headers }).pipe(
      map(this.automapper.curryMany("default", "MemberItem"))
    );
  }

  getMemberCharts(request: any, includeMerged: boolean = false, includeConflicts: boolean = false): Observable<MemberChartM360Response> {
    const url = `${this.baseApiUrl}m360/members/chart/query` +
                 `?includeMergedMemberCharts=${includeMerged}` +
                `&includeConflictMemberCharts=${includeConflicts}`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post(url, request, { headers }).pipe(
      map(this.automapper.curry("default", "MemberChartM360Response"))
    );
  }

  getMemberById(memberId: string, includeMerged: boolean = false, includeConflicts: boolean = false): Observable<any> {
    const headers = new HttpHeaders().set("content-type", "application/json");
    const params = new URLSearchParams();
    params.set("includeConflicts", includeConflicts.toString());
    params.set("includeMerged", includeMerged.toString());
    params.set("memberId", memberId);
    const url = `${this.baseApiUrl}m360/members/memberrecord?${params.toString()}`;
    return this.http.get(url, { headers });
  }
}
